<form [formGroup]="userForm" (ngSubmit)="saveUser(inProgress)">
  <div class=" modal-header pt-2">
    <h5 class="modal-title d-flex align-items-center">
      <i class="bx bx-user-plus me-1 font-20 text-primary"></i>{{userForm.value.id?'Update':'Add'}} User
    </h5>

  </div>
  <div class="modal-body pb-2">
    <div class="row g-3 mb-2">
      <div class="col-md-3">
        <label for="username" class="form-label">Username <b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-user-plus'></i></span>
          <input type="text" class="form-control ps-1" id="username" placeholder="Enter a valid email"
            [ngClass]="{'is-invalid': submitted && u.username.errors}" formControlName="username" ngbAutofocus
            autocomplete="off" />
          <div class="invalid-feedback" *ngIf="submitted && u.username.errors">
            <span *ngIf="u.username.errors.required">Please provide a valid username.</span>
            <span *ngIf="u.username.errors.pattern">Please provide a valid email.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3" *ngIf="ref=='EMPLOYEE'">
        <label for="type" class="form-label">Role<b class="text-secondary">*</b></label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0"><i class='bx bxs-grid-alt'></i></span>
          <ng-select class="form-control rcx-ng-select" formControlName="roleId" placeholder="Select Role"
            [ngClass]="{'is-invalid': submitted && u.roleId.errors}" [clearable]="false">
            <ng-option *ngFor=" let role of roles;" [ngValue]="role.id">{{role.name}}</ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="submitted && u.roleId.errors">
            <span *ngIf="u.roleId.errors.required">Please select a account period.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="password" class="form-label">Password<b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-lock'></i></span>
          <input type="password" class="form-control ps-1" id="password" placeholder="Enter password" #password
            [ngClass]="{'is-invalid': submitted && u.password.errors}" formControlName="password" autocomplete="off"
            (copy)="$event.preventDefault()" (cut)="$event.preventDefault()" (paste)="$event.preventDefault()" />
          <span class="symbol-eye" *ngIf="!(submitted && u.password.errors)">
            <i [class]="password.type==='password'? 'bx bx-low-vision':'bx bx-show'"
              (click)="showPassword(password)"></i>
          </span>
          <div class="invalid-feedback" *ngIf="submitted && u?.password?.errors">
            <span *ngIf="u?.password?.errors?.required">Please provide a valid password.</span>
            <span *ngIf="u?.password?.errors?.pattern">Try a mix of letters, numbers, and symbols.</span>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <label for="confirm" class="form-label">Confirm Password<b class="text-secondary">*</b></label>
        <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
              class='bx bx-lock'></i></span>
          <input type="password" class="form-control ps-1" id="confirm" placeholder="Enter confirm Password" #confirm
            [required]="u?.password?.value "
            [ngClass]="{'is-invalid': submitted && (u?.confirm?.errors || u?.confirm?.value!=u?.password?.value)}"
            formControlName="confirm" autocomplete="off" (copy)="$event.preventDefault()"
            (cut)="$event.preventDefault()" (paste)="$event.preventDefault()" />
          <span class="symbol-eye" *ngIf="!(submitted && u.confirm.errors || (u?.confirm?.value !== u?.password?.value))">
            <i [class]="confirm.type==='password'? 'bx bx-low-vision':'bx bx-show'" (click)="showPassword(confirm)"></i>
          </span>
          <div class="invalid-feedback"
            *ngIf="submitted && (u?.confirm.errors || u?.confirm?.value !== u?.password?.value)">
            <span *ngIf="u.confirm.errors?.required">Please provide a valid password.</span>
            <span *ngIf="u.confirm.errors?.pattern">Try a mix of letters, numbers, and symbols.</span>
            <span *ngIf="!u.confirm.errors && u?.confirm?.value !== u?.password?.value">Password and confirm
              password don't match</span>
          </div>
        </div>
      </div>
      <div class="col-lg-auto ms-auto">
        <button type="submit" class="btn btn-secondary rcx-btn" #inProgress
          [ngClass]="{'no-event':inProgress?.value=='true'}">
          <ng-container *ngIf="inProgress?.value=='true'">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{userForm.value.id?'Updating...':'Saving...'}}
          </ng-container>
          <ng-container *ngIf="inProgress?.value!='true'">
            <i class="bx bx-save"></i>{{userForm.value.id?'Save Changes':'Save'}}
          </ng-container>
        </button>
      </div>
    </div>
  </div>
</form>
